import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ELEMENT_ID } from "utils/constants";
import { useStyles } from "./loadmoreStyle";

const LoadMoreButton = ({ loadMore, loading, isLoadable, enableLoadmore }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <div>
      <Typography align="center">
        {!loading && enableLoadmore && (
          <Button
            onClick={loadMore}
            className={classes.loadMoreButton}
            id={ELEMENT_ID.LOADMORE}
            disabled={!isLoadable}
          >
            {t("load_more")}
          </Button>
        )}
      </Typography>
    </div>
  );
};

export default LoadMoreButton;
